module.exports = __webpack_public_path__ + "static/media/53.6576e8df.jpg";